'use client'

import { Button } from 'fukku/Button'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { dataTestIds } from 'plp/constants/dataTestIds'
import type { FiltersSearchParams } from 'plp/types/Catalog'

import { Filters } from '../../Filters/Filters'
import type { UseFiltersData } from '../../getFiltersData/getFiltersData'

import styles from './FilterWrapper.module.scss'

interface FiltersWrapperProps {
	showAsMediumOrSmall: boolean
	show: boolean
	clientFiltersData: UseFiltersData | null
	defaultFilter?: FiltersSearchParams
	hasServerFilters: boolean
	onFilterClick: () => void
	onClose: () => void
}

export function FiltersWrapper({
	showAsMediumOrSmall,
	show,
	clientFiltersData,
	defaultFilter,
	hasServerFilters,
	onFilterClick,
	onClose,
}: FiltersWrapperProps) {
	const { t } = useLabels()

	return (
		<>
			{showAsMediumOrSmall ? (
				<Button
					secondary
					className={styles.filterButton}
					onClick={onFilterClick}
					width={'fill'}
					data-testid={dataTestIds.plpFilterButton(showAsMediumOrSmall)}
				>
					{t('buscador.filtrar')}
				</Button>
			) : (
				<Button
					secondary
					border={false}
					icon={'filter'}
					onClick={onFilterClick}
					data-testid={dataTestIds.plpFilterButton(showAsMediumOrSmall)}
				>
					{t('buscador.filtrar')}
				</Button>
			)}
			{show && clientFiltersData && (
				<Filters
					isSmall={showAsMediumOrSmall}
					show={show}
					hasServerFilters={hasServerFilters}
					defaultFilter={defaultFilter}
					onClose={onClose}
					filtersData={clientFiltersData}
				/>
			)}
		</>
	)
}
